import LocalStorage from '../../../helpers/LocalStorage';
import DistillateFormValidation from './DistillateFormValidation';
import RecieverForm from '../shared/RecieverForm';
import formFields from './json/formFields.json';

/**
 * Distillate review class
 */
export default class DistillateReview {
    constructor(validThroughDate) {
        this.storageName = 'distillate';
        this.validation = new DistillateFormValidation();
        this.storage = new LocalStorage();
        this.RecieverForm = new RecieverForm('distillate');
        this.validThroughDate = validThroughDate;
        this.payload = {};
        this.formFields = formFields;
        this.InitEventListerners();
    }

    /**
     * Event Listerners
     */
    InitEventListerners() {
        this.listenFormInteraction('.step2');
        this.listenFormInteraction('.step1');
    }

    /**
     * Listen to form interaction
     * @param {*} step
     */
     listenFormInteraction(step) {
        for (let item of document.querySelectorAll(step)) {
            item.addEventListener('change', () => {
                this.setDataFromInput();
                this.storeData();
            });
        }
    }

    /**
     * Store data
     */
    storeData() {
        this.setDataFromInput();
        for (const item of document.querySelectorAll('.distillateForm')) {
            if(item.type !== 'checkbox') {
                this.payload[item.id] = item.value ? item.value : null;
            }
        }
        
        this.storage.setItem(this.storageName, this.payload);
    }

    /**
     * Setting payload from Helper
     * @param {*} payLoadData
     */
    preparePayLoad(payLoadData) {
        this.payload[Object.keys(payLoadData)[0]] = payLoadData[Object.keys(payLoadData)[0]];
        this.storeData();
    }

    /**
     * Set Review data for payload from Form input/Interaction
     */
    setDataFromInput() {
        this.payload.deliveryAddresses = [];
        let reviewAddressData = ``;

        for (let key in JSON.parse(JSON.stringify(this.formFields))) {
            if (formFields[key].type === 'checkbox') {
                document.querySelectorAll('.form-addresses:checked').forEach((checkbox, i) => {
                    let delivery = {
                        'address': checkbox.getAttribute('data-address-number'),
                        'zipCity': checkbox.getAttribute('data-zipcity')
                    }

                    this.payload.deliveryAddresses[i] = delivery;

                    reviewAddressData += `${checkbox.getAttribute('data-address')}, 
                            ${checkbox.getAttribute('data-zipcity')}<br />`;
                });

                document.querySelector(formFields[key].fields.reviewId).innerHTML =
                    reviewAddressData;
                this.validateNextStep();
            }

            if (formFields[key].type === 'text') {
                document.querySelector(formFields[key].fields.reviewId).innerHTML =
                    document.querySelector(formFields[key].fields.id).value;

                this.payload[key] = document.querySelector(formFields[key].fields.id).value;
            }
        }

        // AddressId
        // ---------------------------------------------
        if(this.payload.deliveryAddresses.length > 0) {
            this.payload.addressId = this.payload.deliveryAddresses[0].address;
        }
        
        // Email & End date
        // ---------------------------------------------
        this.payload.emailAddress = document.querySelector('#emailAddress').value;
        this.payload.validThroughDate = this.validThroughDate;
    }

    /**
     * Validate and enable/disable next step button
     */
    validateNextStep() {
        if (document.querySelector('.form-addresses:checked') !== null) {
            document.querySelector('#Step1Next').classList.remove('disabled');
        } else {
            document.querySelector('#Step1Next').classList.add('disabled');
        }
    }

    /**
     * Get payLoad data
     * @returns {} Object
     */
    getPayload() {
        return this.payload;
    }
}
